import * as React from 'react';

type LinkProps = {
  children: React.ReactNode;
  className?: string;
  onClick: () => void;
  testId?: string;
};

export const Link: React.VFC<LinkProps> = ({
  children,
  className,
  onClick,
  testId,
}) => {
  return (
    <a
      className={className}
      data-testid={testId}
      href="#"
      onClick={(evt) => {
        evt.preventDefault();
        onClick();
      }}
    >
      {children}
    </a>
  );
};
